export default "__VITE_ASSET__DjEy$3mn__"